module.exports = __webpack_public_path__ + "img/sc-gallery-2.5361c049.jpg";